/**
 * @fileoverview Duration formatting for the pipeline progress display.
 */

/** Compact duration: 840ms, 4.2s, 1m 05s. */
export function formatDuration(ms) {
  if (ms == null || Number.isNaN(ms)) return '—';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  const minutes = Math.floor(ms / 60000);
  return `${minutes}m ${String(Math.round((ms % 60000) / 1000)).padStart(2, '0')}s`;
}

/** Deliberately vague: an ETA presented to the millisecond invites distrust. */
export function formatEta(ms) {
  if (ms == null || ms <= 0) return 'finishing up';
  if (ms < 2000) return 'about a second left';
  if (ms < 60000) return `about ${Math.round(ms / 1000)}s left`;
  return `about ${Math.ceil(ms / 60000)} min left`;
}
